import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebook,
  faPinterest,
} from "@fortawesome/free-brands-svg-icons";
import { faMapMarkerAlt, faPhoneAlt } from "@fortawesome/free-solid-svg-icons"; // Keep location icon in solid
import "./Footer.css";
import Footer_logo from "../../Assets/gold.png";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

export const Footer = ({ showBothDivs }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="Footer-main bg-dark-red py-5">
      <div className="container"> 
        <div className="row justify-content-between">
          {/* Logo & Address Section */}
          <div className="col-lg-3 col-md-6 mb-4 text-center">
            <img src={Footer_logo} alt="logo" width={160} className="mb-3" />
            <div className="address text-light d-flex justify-content-center">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 mt-1" />
              <span className="text-light" style={{ fontSize: "16px", textAlign: "justify" }}>
                B1-31, Target Mall, Chandavarkar <br /> Road, Opp. Rajmahal Hotel, <br />
                Borivali West, Mumbai - 400092.
              </span>
            </div>
            <div className="phone-number text-light mt-2 d-flex justify-content-center">
              <FontAwesomeIcon icon={faPhoneAlt} className="me-2" />
              <span style={{ fontSize: "16px" }}>
                +91 70213 07984
              </span>
            </div>
            <div className="delivery-time mt-2 text-light d-flex justify-content-center">
              <small style={{ fontSize: "16px" }}>
                🚚 Delivery Time: <strong>5-7 Days</strong>
              </small>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="col-lg-3 col-md-6 mb-4 text-center">
            <h5 className="text-light text-uppercase">Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <NavLink to="/" className="footer-link" onClick={scrollToTop}>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/products"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Products
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Policies Section */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="text-light text-uppercase">Policies</h5>
            <ul className="list-unstyled">
              <li>
                <NavLink
                  to="/privacy-policy"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Privacy Policy
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/shipping-policy"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Shipping Policy
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/return-refund-policy"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Return & Refund
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/terms-conditions"
                  className="footer-link"
                  onClick={scrollToTop}
                >
                  Terms & Conditions
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="col-lg-3 col-md-6 mb-4 text-center">
            <h5 className="text-light text-uppercase">Follow Us</h5>
            <div className="d-flex justify-content-center gap-3">
              <a
                href="https://www.facebook.com/share/1HC6QCVpCw/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faFacebook}
                  size="2x"
                  className="social-icon"
                />
              </a>
              <a
                href="https://www.instagram.com/tarunika.in?igsh=MXBwc2g0dnhtdjlpMw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  size="2x"
                  className="social-icon"
                />
              </a>
              <a
                href="https://pin.it/2AWy1jwqa"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faPinterest}
                  size="2x"
                  className="social-icon"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Horizontal Line Above Copyright */}
        <hr className="footer-line" />

        {/* Footer Bottom */}
        <div className="text-center mt-4">
          <p className="mb-0 text-light">
            &copy; 2024 Tarunika. Made With Love By | {" "}
            <a
              href="https://dbuggedprogrammers.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
              style={{color: "#ffd404"}}
            >
              D'Bugged Programmers
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
